import { useQuery } from "@tanstack/react-query";
import { SocialPlatformsAPI, SocialPlatformsGetAPI } from "../api";

const fetchData = () => {
  return SocialPlatformsGetAPI.get();
};

export const useFetchSocialPlatforms = () => {
  return useQuery({
    queryKey: ["social-platform"],
    queryFn: fetchData,
    keepPreviousData: true, // smooth switching
  });
};
